import React, {Component} from 'react';
import {Col, Form, Input, Row, Button, Pagination, Popover, Spin, Modal, Icon, Popconfirm} from "antd"
import {api, app} from "../../app"
import config from "../../config";
import utils from "../../utils";
import PayTemplate from "../../components/PayTemplate"
import MineTrainDetails from "./MineTrainDetails"
import xzs from "../../assets/xzs.jpg";

const FormItem = Form.Item

class MineTrainList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject_id:'',//附近班级id
            total: 0,
            page: 1,
            dataList:[],
            name:'',
            idno:'',
            pay_loading:false

        }
    }

    async componentDidMount() {
        this._isMounted = true;
        if(this.props.location.state){
            let name = this.props.location.state.name,
            idno = this.props.location.state.idno
            this.props.form.setFieldsValue({ name: name, idno: idno })
            await this.setData({name: name, idno:idno})
            await this.myList()
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 提交
     **/
    handleAdd = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (err) {
                return;
            }
            await this.setData({name: values.name, idno:values.idno})
            await this.myList()
        })
    }

    /**
     * 我的培训列表
     */
    myList = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { name,idno } = this.state,
        params = {
            page,
            vname:name,
            idno:idno,
        }
        let { flag, data, msg, total } = await app.post(api.SkillTrainMyTrainings, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: data, data_loading: false, total: Number(total || 0) })
    }

    //取消培训
    cancel = async (ordersNo) => {
        let { page } = this.state,
            params = {
                orders_no:ordersNo
            }
        const { flag, msg } = await app.post(api.SkillTrainCancel, params)
        if (flag === 1) {
            app.alert('操作成功', 'success')
            await this.myList(page)
            return true
        } else {
            app.alert(msg, 'warn')
            throw false
        }
    }

    //订单支付
    pay = async (ordersNo,type) => {
        let {pay_loading,page} = this.state,
            params = {
                orders_no:ordersNo,
                pay_method:type
            }
        if (pay_loading) return false
        await this.setData({pay_loading: true})
        const { flag, data, msg } = await app.post(api.SkillTrainOrdersZhifu, params)
        app.alertDestroy()
        if (flag === 1) {
            Modal.confirm({
                title: '扫码支付',
                centered: true,
                icon: type==2?(<Icon type="alipay-circle" style={{ color: '#00A1E9' }} />):(<Icon type="wechat" style={{color: '#00D30C'}}/>),
                width: 600,
                content: type==2?(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} />):(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} terminal="微信" />),
                okText: '已支付',
                cancelText: '关闭',
                onOk: async () => {
                    const { flag, msg } = await app.post(api.SkillTrainConfirmPay, {
                        orders_no: data.ordersNo
                    })
                    if (flag === 1) {
                        app.alert('支付成功', 'success')
                        await this.myList(page)
                        return true
                    } else {
                        app.alert(msg, 'warn')
                        throw false
                    }
                }
            })
        } else {
            app.alert(msg, 'warn')
        }
        await this.setData({ pay_loading: false })
    }

    /**
     * 打开近期开班详情
     */
    recentOpeningModal = async (obj) => {
        console.log(obj)
        await this.setData({ orders_no:obj.orders_no,recent_title:obj.train_name, recent_modal: true })
    }

    /**
     * 关闭近期开班详情
     */
    recentCloseModal = async (obj) => {
        let {page} = this.state;
        await this.setData({ recent_modal: false })
        await this.myList(page)
    }

    // 支付状态名
    payName = (e) => {
        switch (e) {
            case '1':
                return '已支付'
                break;
            case '2':
                return '已退款'
                break;
            case '3':
                return '已取消'
                break;
        }
    }

    // 培训状态名
    trainStatusName = (e) => {
        switch (e) {
            case '0':
                return '未开始'
                break;
            case '1':
                return '进行中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let { page,total,dataList,data_loading,recent_modal,recent_title,orders_no,visible,imgUrl } = this.state,
            { form } = this.props,
            { getFieldDecorator } = form
        return (
            <div className="mine-train">
                <div className="my-title">我的培训</div>
                <div className="my-list">
                    <div className="my-search">
                        <Form onSubmit={this.handleAdd}>
                            <Row className="my-search-r">
                                <Col span={21}>
                                    <FormItem labelAlign="left" labelCol={{ span: 4, offset:1 }} wrapperCol={{ span: 18 }} label="姓名">
                                        {getFieldDecorator('name', {
                                            rules: [{ required: true, message: '请输入姓名!' }],
                                        })(
                                            <Input placeholder="请输入姓名"/>
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row className="my-search-r">
                                <Col span={21}>
                                    <FormItem labelAlign="left" labelCol={{ span: 4,offset:1 }} wrapperCol={{ span: 18 }} label="身份证号码">
                                        {getFieldDecorator('idno', {
                                            rules: [{ required: true, message: '请输入身份证号码!' }],
                                        })(
                                            <Input placeholder="请输入身份证号码"/>
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={3}>
                                    <Button style={{width:'90px',marginTop:'3px'}} type="primary" htmlType="submit" block>查询</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    <div className="list-data">
                        {dataList.length > 2?
                            <div style={{width:'1000px',textAlign:'right',margin:'15px auto'}}>
                                <Pagination
                                    size="small"
                                    current={page}
                                    total={total}
                                    pageSize={20}
                                    showTotal={(t) => `总数量：${t}`}
                                    onChange={this.myList}
                                />
                            </div>
                        :null}
                        {data_loading?(<div className="mall-loading"><Spin size="large"/></div>):
                            dataList.map((item,index) => {
                                return (
                                    <div key={index} className="list-data-r">
                                        <Row type="flex" justify="center">
                                            <Col span={11}>
                                                <Row>
                                                    <Col className="list-data-c" span={24}>姓名：{item.name}</Col>
                                                    <Col className="list-data-c" span={24}>期望开班城市：{item.province_name}/{item.city_name}</Col>
                                                    <Col className="list-data-c" span={24}>培训课程：{item.train_name}</Col>
                                                    <Col className="list-data-c" span={24}>培训科目：{item.names}</Col>
                                                    <Col className="list-data-c" span={24}>培训天数：{item.train_day}天</Col>
                                                    <Col className="list-data-c" span={24}>考评天数：{item.evaluate_day}天</Col>
                                                    {/*<Col className="list-data-c" span={24}>培训总费用：{item.train_amount}元</Col>*/}
                                                </Row>
                                            </Col>
                                            <Col span={11}>
                                                <div className="list-data-right">
                                                    <Row>
                                                        <Col className="list-data-c" span={15} offset={9}>培训总费用：{item.train_amount}元</Col>
                                                        {item.apply_count > 10?
                                                            <Col className="list-data-c" span={15} offset={9}>已报名人数：{item.apply_count}人</Col>
                                                        :null}
                                                        <Col className="list-data-c" span={15} offset={9}>报名状态：{item.apply_status}</Col>
                                                        {item.have_paid?(
                                                            <Col className="list-data-c" span={15} offset={9}>已支付费用：<span>{item.have_paid}</span></Col>
                                                        ):null}
                                                        {item.pay_money?(
                                                            <Col className="list-data-c" span={15} offset={9}>待支付：<span className="red">{item.pay_money}</span></Col>
                                                        ):null}
                                                        {
                                                            '123'.indexOf(item.pay_status) > -1 ? (
                                                                <Col className="list-data-c" span={15} offset={9}>支付状态：<span>{this.payName(item.pay_status)}</span></Col>
                                                            ) : null
                                                        }
                                                        <Col className="list-data-c" span={15} offset={9}>培训状态：{this.trainStatusName(item.train_status)}</Col>
                                                    </Row>
                                                    <Row type="flex" justify="end" className="row-bottom">
                                                        <Col span={5}><Button type="primary" onClick={()=> this.recentOpeningModal(item)} block>详情</Button></Col>
                                                        {
                                                            '0'.indexOf(item.pay_status) > -1 ? (
                                                                <Col style={{marginLeft:'15px'}} span={5}>
                                                                <Popconfirm title="确认取消？" onConfirm={() => this.cancel(item.orders_no)} okText="是" cancelText="否">
                                                                    <Button type="primary" block>取消</Button>
                                                                </Popconfirm>
                                                                </Col>
                                                            ):null
                                                        }
                                                        {/*<Col span={5}><Button type="primary" block>转班</Button></Col>*/}
                                                        {
                                                            '04'.indexOf(item.pay_status) > -1 ? (
                                                                <Col style={{marginLeft:'15px'}} span={5}>
                                                                <Popover
                                                                    content={<div><Button onClick={() =>this.pay(item.orders_no,1)} type="primary">微信</Button><Button onClick={() =>this.pay(item.orders_no,2)} type="primary" style={{marginLeft:'10px'}}>支付宝</Button></div>}
                                                                    title="付款方式"
                                                                >
                                                                    <Button type="primary" block>前往支付</Button>
                                                                </Popover>
                                                                </Col>
                                                            ) : null
                                                        }
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            })
                        }
                        {dataList.length > 0?
                            <div style={{width:'1000px',textAlign:'right',margin:'15px auto'}}>
                                <Pagination
                                    size="small"
                                    current={page}
                                    total={total}
                                    pageSize={20}
                                    showTotal={(t) => `总数量：${t}`}
                                    onChange={this.myList}
                                />
                            </div>
                        :null}
                        <div class="flex">
                            <Popover placement="top" content={<img src={config.imgUrl+'/Uploads/8459ujjf998jjkJJDJ8KE83JD934J89M44JJ090kd9dk.jpg'} alt="" width="250" height="250"/>} trigger="hover">
                                <Button style={{width:'300px',margin:'15px auto'}} type="primary" block>我要报名</Button>
                            </Popover>
                        </div>
                    </div>
                </div>
                <img className="mine-banner" src={config.imgUrl+'/Uploads/Ppe/discount_banner_img_pc.png'}></img>

                <Modal
                    visible={recent_modal}
                    title={recent_title}
                    footer={null}
                    width="50%"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.recentCloseModal}
                    bodyStyle={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}
                    style={{ paddingBottom: 0, top: 70 }}
                    className="list-data-modal-class"
                >
                    <MineTrainDetails orders_no={orders_no}/>
                </Modal>
            </div>
        );
    }
}
export default Form.create()(MineTrainList);



// WEBPACK FOOTER //
// ./src/routes/skillTrain/MineTrainList.jsx